import React from "react";
import { useNavigate } from "react-router-dom";
import D2IntegrationDiagram from "./D2IntegrationDiagram";

/**
 * IntegrationSummaryCard — Final card shown after integration is created.
 * Shows the D2 diagram, a prominent "Edit Integration" banner, and a Dashboard button.
 *
 * Props:
 *   data        — integration data including flow_graph
 *   isEditable  — bool: show Edit banner (only on last done card)
 *   onEdit      — ()=>void: fires when Edit clicked
 */
const IntegrationSummaryCard = ({ data, isEditable = false, onEdit }) => {
  const navigate = useNavigate();
  if (!data) return null;

  const displayId = data.integration_id || data.pipeline_id;
  const isSequential = data.pipeline_type === 'sequential';
  const detailPath = isSequential
    ? `/integrations/sequential/${displayId}`
    : `/integrations/${displayId}/details`;

  return (
    <div className="w-full my-2 space-y-2">
      {/* D2 Diagram */}
      <div className="rounded-xl border border-blue-100 bg-gray-50 overflow-hidden">
        <div className="px-3 py-1.5 border-b border-blue-100 bg-blue-50">
          <span className="text-[0.65rem] font-black uppercase tracking-widest text-blue-600">Workflow Diagram</span>
        </div>
        <D2IntegrationDiagram
          flowGraph={data.flow_graph}
          triggerPlatform={data.trigger_platform}
          destinationPlatform={data.destination_platform}
          onEdit={isEditable ? onEdit : null}
        />
      </div>

      {/* Dashboard button */}
      {displayId && (
        <button
          onClick={() => navigate(detailPath)}
          className="w-full py-2 rounded-lg bg-blue-600 text-white text-[0.82rem] font-bold hover:bg-blue-700 transition shadow-sm active:scale-[0.98]"
        >
          View on Dashboard →
        </button>
      )}
    </div>
  );
};

export default IntegrationSummaryCard;
